import { useCallback, useRef } from 'react';

/**
 * Alternative infinite scroll hook using onItemsRendered
 * This is more reliable for react-window
 */
export const useInfiniteScrollAlt = ({ onLoadMore, hasMore, loading, itemCount, threshold = 3 }) => {
  const isLoadingRef = useRef(false);

  const handleItemsRendered = useCallback(
    ({ visibleStopIndex }) => {
      // Don't trigger if already loading or no more items
      if (!hasMore || loading || isLoadingRef.current) {
        return;
      }

      // Trigger when user is within `threshold` items of the end
      if (itemCount - visibleStopIndex <= threshold) {
        isLoadingRef.current = true;

        // Call onLoadMore and ensure it returns a Promise
        const loadPromise = onLoadMore();

        // Handle both Promise and non-Promise returns
        if (loadPromise && typeof loadPromise.finally === 'function') {
          loadPromise.finally(() => {
            isLoadingRef.current = false;
          });
        } else {
          // If not a Promise, reset immediately
          isLoadingRef.current = false;
        }
      }
    },
    [hasMore, loading, onLoadMore, itemCount, threshold]
  );

  return handleItemsRendered;
};
